(function () {
    'use strict';

    angular
        .module('app')
        .controller('searchCard', searchCard);

    searchCard.$inject = [
        'dataCardService',
        'gridDataService',
        'searchService',
        'appendSearchService',
        'enumFactory',
        '$state',
        '$rootScope',
        '$q',
        '$scope',
        'loginService',
        '$filter',
        '$timeout',
        'refineSearchService',
        'sidebarservice',
        'lastSearchService',
        'columnFactory',
        'fileGuideService',
        'libraryService'
    ];


    function searchCard(dataCardService, gridDataService, searchService, appendSearchService, enumFactory, $state, $rootScope, $q, $scope, loginService, $filter, $timeout,
        refineSearchService, sidebarservice, lastSearchService, columnFactory, fileGuideService, libraryService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'searchCard';
        vm.data = [];
        vm.dataCardService = dataCardService;
        vm.searchService = searchService;
        vm.selectedCard = {};
        vm.processing = false;
        vm.schemaModels = {};
        vm.schemaModelsDates = {};  //included to hold date models specifically (separated from schemaModels)
        vm.selectOptions = {};
        vm.restrictedModel = [];
        vm.restrictedText = {};
        vm.restrictedSelected = {};
        vm.currentDataCardId = "";
        vm.previousSearchCriteria = "";
        vm.allowRefine = true;
        vm.allowAppend = true;
        vm.columnFactory = columnFactory;
        vm.gridDataService = gridDataService;
        vm.filter = $filter;
        vm.loginService = loginService;
        vm.showCharWarning = false;
        //gets the current data card from the server
        dataCardService.getStructure().then(function () {
            //get the last search criteria
            vm.previousSearchCriteria = "";

            lastSearchService.getLastSearchOperations().then(function (value) {
                vm.previousSearchCriteria = value;
            });

            //if the thumbnail tab is the last selected, select the the first tab.
            if (dataCardService.activeTab > dataCardService.tabs.length - 2) {
                dataCardService.activeTab = 0;
            }

        });

        //handles the library selection event
        vm.dataCardChanged = function () {
            dataCardService.changeCard();
        };

        vm.gotoGrid = function () {
            $state.go('layout.results.grid');
        }

        vm.textBoxHeight = 30;

        //upon reentry of the form, criteria values are entered into the value boxes for that field
        angular.forEach(dataCardService.searchCriteria, function (value, key, obj) {

            //separate the date and non-date models
            if (isDateCriteria(value.schemaID) == true) {
                //date model
                vm.schemaModelsDates[value.schemaID] = value;
            }
            else {
                //non-date model
                vm.schemaModels[value.schemaID] = value.valueStr;
                //add item to restricted list (could be cleaned up)
                vm.restrictedText[value.schemaID] = value.valueStr;
            }
        });

        //a function to return true if given schema id is a date field on the card
        function isDateCriteria(value) {
            var isDate = false;
            //separate the date and non-date models
            angular.forEach(vm.dataCardService.tabs, function (tabItem, tabKey) {
                if (isDate == false) {
                    angular.forEach(tabItem.dates, function (dateItem, dateKey) {
                        if (dateItem.dataCardControlDefinition.id == value) {
                            isDate = true;
                        }
                    });
                }
            });
            return isDate;
        }

        // =======================================================
        // Blank Children - Begin
        // =======================================================

        var blankChild = function (fieldsPacket, initialSchemaId, schemaId) {
            // Walk the fields packet.
            var count = fieldsPacket.fieldsPacket.length;
            for (var i = 0; i < count; i++) {
                var fieldPacket = fieldsPacket.fieldsPacket[i];
                if (fieldPacket.schemaId == schemaId) {
                    //// If not the root field, blank it.
                    //if (fieldPacket.schemaId != initialSchemaId) {
                    //    // Update value.
                    //    vm.inputModel[fieldPacket.schemaId] = "";
                    //    // Mark as dirty.
                    //    vm.inputChanged("", fieldPacket.schemaId);
                    //}
                    // If the current field has children, ...
                    if (fieldPacket.childSchemaIds != null) {
                        // Walk the children.
                        var childCount = fieldPacket.childSchemaIds.length;
                        for (var j = 0; j < childCount; j++) {
                            var childSchemaId = fieldPacket.childSchemaIds[j];

                            //blankChild(fieldsPacket, initialSchemaId, childSchemaId);

                            // Update value.
                            vm.schemaModels[childSchemaId] = "";
                            // Mark as dirty.
                            //vm.inputChanged("", childSchemaId); // This will recurse.
                            //vm.dirtyInputs[childSchemaId] = true;
                            blankChild(fieldsPacket, initialSchemaId, childSchemaId);
                        }
                    }

                    if (fieldPacket.autofillSchemaIds != null) {
                        // Walk the children.
                        var childCount = fieldPacket.autofillSchemaIds.length;
                        for (var j = 0; j < childCount; j++) {
                            var childSchemaId = fieldPacket.autofillSchemaIds[j];

                            //blankChild(fieldsPacket, initialSchemaId, childSchemaId);

                            // Update value.
                            vm.schemaModels[childSchemaId] = "";
                            // Mark as dirty.
                            //vm.inputChanged("", childSchemaId); // This will recurse.
                            //vm.dirtyInputs[childSchemaId] = true;
                            blankChild(fieldsPacket, initialSchemaId, childSchemaId);
                        }
                    }

                    break;
                }
            }
        }

        var blankChildren = function (schemaId) {
            var fieldsPacket = dataCardService.fieldsPacket;
            blankChild(fieldsPacket, schemaId, schemaId);
        }

        // =======================================================
        // Blank Children - End
        // =======================================================

        //event handler for all inputs, it updates the search criteria real time.
        vm.inputChanged = function (id) {
            vm.showCharWarning = false;
            //method to display the message that the character is not allowed.
            var showMessage = function (schemaId) {
                vm.showCharWarning = true;
                removeLastChar(schemaId);
                $timeout(function () {
                    vm.showCharWarning = false;
                }, 2000);
            }

            //This section handles the validation of the input entered in the quicksearch depending on the field selected.
            var isNumeric = function (input) {
                return (input - 0) == input && ('' + input).trim().length > 0;
            }

            //function removes the last charachter entered.
            var removeLastChar = function (schemaId) {
                if (vm.schemaModels[schemaId].length > 1) {
                    vm.schemaModels[schemaId] = vm.schemaModels[schemaId].slice(0, vm.schemaModels[schemaId].length - 1);
                }
                else {
                    vm.schemaModels[schemaId] = "";
                }
            }
 
            // It just adds extra search criteria.
            handleAutofill(id, vm.schemaModels[id]);

            blankChildren(id);

            //clear the criteria for rebuild
            dataCardService.searchCriteria = [];
            //iterate through each schemaModel (note, does not include date models - see schemaModelDate)
            //build the criteria object, creating a new object as the second parameter to the buildCriteria function 
            angular.forEach(vm.schemaModels, function (value, key, obj) {
                if (value != "" && value != undefined) {
                    var colDef = $filter('filter')(vm.columnFactory.availableColumns, { schemaID: key })[0];

                    if (colDef) {
                        switch (colDef.fieldType) {
                            case 3:
                            case 4:
                            case 8:
                                //check the last character entered
                                if (!isNumeric(value[value.length - 1])) {
                                    var charsToSearch = [">", "<", "!"];
                                    //check if any of the allowed characters was entered
                                    if (charsToSearch.indexOf(value[value.length - 1]) > -1) {
                                        //check if it's the first character entered
                                        if (value.length == 1) {
                                            //let it go
                                            break;
                                        }

                                    }
                                    showMessage(key);
                                    value = vm.schemaModels[key];
                                    break;
                                }
                            default:
                                //never allow a wildcard
                                if (value.indexOf("?") > -1 && sidebarservice.databaseType == 2) {
                                    showMessage(key);
                                    value = vm.schemaModels[key];
                                    break;
                                }
                                var charsToSearch = [">", "<", "!", "*"];
                                //check if any of the allowed characters was entered
                                var char = value[value.length - 1];
                                if (charsToSearch.indexOf(char) > -1) {
                                    //check if it's the first character entered
                                    if (value.length == 1) {
                                        //let it go
                                        break;
                                    }
                                    else {
                                        if (char === "*" && sidebarservice.databaseType === 1) {
                                            break;
                                        }
                                        showMessage(key);
                                        value = vm.schemaModels[key];
                                        break;
                                    }
                                }
                                break;
                        }
                    }
                    

                    if (value != "") {
                        vm.buildCriteria(key, {
                            "schemaID": key,
                            "valueStr": value,
                            "startDate": "",
                            "endDate": "",
                            "searchOp": enumFactory.searchOperator.Starts
                        });
                    }

                }
            });

            vm.allowAppend = true;
            vm.allowRefine = true;

            if (vm.schemaModels.__SEARCH_ALL_FIELDS__) {
                if (vm.schemaModels.__SEARCH_ALL_FIELDS__.length > 0) {
                    vm.allowAppend = false;
                    vm.allowRefine = false;
                }
            }


            //iterate through each schemaModelDate (specific to date models)
            angular.forEach(vm.schemaModelsDates, function (value, key, obj) {
                if (value != "" && value != undefined) {
                    //build the criteria object using the value object - expected to be criteria object as it 
                    // comes from the schemaModelDate object
                    vm.buildCriteria(key, value);
                }
            });
        }


        function handleAutofill(schemaId, value) {
            if (value != null && value.length > 0) {
                var fieldsPacket = dataCardService.fieldsPacket;
                // Walk the fields packet.
                var count = fieldsPacket.fieldsPacket.length;
                for (var i = 0; i < count; i++) {
                    var fieldPacket = fieldsPacket.fieldsPacket[i];
                    if (fieldPacket.schemaId == schemaId) {
                        // If the current field has autofill fields, then call the server.
                        if (fieldPacket.autofillSchemaIds != null) {

                            // Get all of the parent values, and put this one on the end.
                            var values = getParentValues(schemaId);
                            values.push(value);

                            dataCardService.getAutofillValues(schemaId, values).then(function (autofillPackets) {
                                // Walk the items.
                                var autofillCount = autofillPackets.length;
                                for (var j = 0; j < autofillCount; j++) {
                                    var autofillPacket = autofillPackets[j];
                                    // Update value.
                                    vm.schemaModels[autofillPacket.name.schemaId] = autofillPacket.name.value;

                                    // Reversed.
                                    // Mark as dirty.
                                    //vm.inputChanged(autofillPacket.name.schemaId, autofillPacket.name.value);
                                    vm.inputChanged(autofillPacket.name.value, autofillPacket.name.schemaId);
                                }
                            });
                        }
                        break;
                    }
                }
            }
        }


        //date operator options for date search object
        //these operations coincide with the awcDatePicker.dateOperations
        var dateOperations = {
            OnDate: 0,
            AfterDate: 1,
            BeforeDate: 2,
            DateRange: 3,
            HasDate: 4,
            HasNoDate: 5
        }

        //build the search criteria using the criteria object 
        vm.buildCriteria = function (key, searchCriteria) {
            //setting the value string provides a way to display the value in the input box
            dataCardService.searchCriteria.push(
            {
                "schemaID": key,
                "valueStr": searchCriteria.valueStr,
                "startDate": searchCriteria.startDate,
                "endDate": searchCriteria.endDate,
                "searchOp": searchCriteria.searchOp,
            });

        }

        //wildcard characters for Adept date searching
        var wildcards = {
            HasDate: '+',
            HasNoDate: '`'
        }

        //// DATEFMTWND - Convert from whatever "Local" came out of the date picker to our local.
        vm.checkDateFormat = function (tmp) {
        //    if (searchService.dateFormat == 4) { // DATE_FMT.DF_WINDOWS
        //        // DATEFMTWND
        //        tmp = dataCardService.localDateStringToStd(tmp);
        //    }
            return tmp;
        }

        //fired once the date is chosen.  sDate is awcDatePicker scope.dateSearch object
        vm.onDatePicked = function (id, sDate) {
            //build the proper criteria packet based on the date operation
            switch (sDate.dateOperation) {
                case dateOperations.OnDate:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": vm.checkDateFormat(sDate.onDateSearchValue),
                        "startDate": vm.checkDateFormat(sDate.onDateSearchValue),
                        "endDate": "",
                        "searchOp": enumFactory.searchOperator.OnDate,
                    });
                    break;
                case dateOperations.AfterDate:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": vm.checkDateFormat(sDate.afterDateSearchValue),
                        "startDate": vm.checkDateFormat(sDate.afterDateSearchValue),
                        "endDate": "",
                        "searchOp": enumFactory.searchOperator.AfterDate,
                    });
                    break;
                case dateOperations.BeforeDate:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": vm.checkDateFormat(sDate.beforeDateSearchValue),
                        "startDate": vm.checkDateFormat(sDate.beforeDateSearchValue),
                        "endDate": "",
                        "searchOp": enumFactory.searchOperator.BeforeDate,
                    });
                    break;
                case dateOperations.DateRange:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": "Range",
                        "startDate": vm.checkDateFormat(sDate.afterDateSearchValue),
                        "endDate": vm.checkDateFormat(sDate.beforeDateSearchValue),
                        "searchOp": enumFactory.searchOperator.DateRange,
                    });
                    break;
                case dateOperations.HasDate:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": "Is not empty",
                        "startDate": wildcards.HasDate,
                        "endDate": "",
                        "searchOp": enumFactory.searchOperator.NotEmpty,
                    });
                    break;
                case dateOperations.HasNoDate:
                    vm.schemaModelsDates[id] = (
                    {
                        "schemaID": id,
                        "valueStr": "Is empty",
                        "startDate": wildcards.HasNoDate,
                        "endDate": "",
                        "searchOp": enumFactory.searchOperator.Empty,
                    });
                    break;
                default:
                    //remove the entry
                    delete vm.schemaModelsDates[id];
            }
            //fire event to add date values to criteria collection
            vm.inputChanged();
        }

        //gets restricted fields data for the selection box
        vm.getRestricted = function (schemaId) {

            var deferred = $q.defer();
            var options = [];
            dataCardService.getRestrictedValues(schemaId).then(function (items) {
                angular.forEach(items, function (item, key) {
                    if (item.name != "") {
                        options.push(item.name);
                    }
                })
                deferred.resolve(options);
            });
            return deferred.promise;

        };


        // =======================================================
        // Dropdown - Related Fields - Begin
        // =======================================================

        // Look for a schema id in the fields packet.
        // If found, return the parent's schema id and the current value.
        var getParentValue = function (fieldsPacket, schemaId) {
            // Walk the fields packet.
            var count = fieldsPacket.fieldsPacket.length;
            for (var i = 0; i < count; i++) {
                var fieldPacket = fieldsPacket.fieldsPacket[i];
                // If the current field has children, ...
                if (fieldPacket.childSchemaIds != null) {
                    // Walk the children.
                    var childCount = fieldPacket.childSchemaIds.length;
                    for (var j = 0; j < childCount; j++) {
                        var childSchemaId = fieldPacket.childSchemaIds[j];
                        // If the current child is the schema id that we are looking for, ...
                        if (childSchemaId == schemaId) {
                            // Return schemaId of the parent, and its current value.
                            return { schemaId: fieldPacket.schemaId, value: vm.schemaModels[fieldPacket.schemaId] };
                        }
                    }
                }
            }
            // The requested schemaId was not found as a child in the entire fields packet.
            return null;
        };

        // Build an array of parent values.
        var getParentValues = function (schemaId) {
            var rtn = [];
            var fieldsPacket = dataCardService.fieldsPacket;
            var parentInfo = getParentValue(fieldsPacket, schemaId);
            while (parentInfo != null) {
                rtn.unshift(parentInfo.value);
                parentInfo = getParentValue(fieldsPacket, parentInfo.schemaId);
            }
            return rtn;
        }

        //gets restricted fields data for the selection box
        vm.getDropdownListValues = function (schemaId) {

            // look up the field in the datacard structure
            var parentValues = getParentValues(schemaId);

            var deferred = $q.defer();
            var options = [];
            dataCardService.getDropdownListValues(schemaId, parentValues).then(function (items) {
                deferred.resolve(items);
            });
            return deferred.promise;
        };

        // =======================================================
        // Dropdown - Related Fields - End
        // =======================================================

        //filter for select box control to act like autocomplete
        function createFilterFor(searchText) {
            var lowercaseQuery = angular.lowercase(searchText);
            return function filterFn(item) {
                return (angular.lowercase(item.name).indexOf(lowercaseQuery) === 0);
            };
        }

        //
        vm.searchTextChanged = function (schemaId) {
            vm.inputChanged(schemaId); // Passing schemaId through.
        }

        //search method
        vm.search = function () {
            vm.processing = true;
            libraryService.clearSelectedNodes();
            fileGuideService.clearSelectedNodes();
            gridDataService.genericDataService = searchService;
            searchService.searchCriteria = dataCardService.searchCriteria;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;

            //gridDataService.data = [];

            //go to the grid
            $state.go('layout.results.grid').then(function () {
                gridDataService.reloadGrid();
            });
        }

        //search method
        vm.appendSearch = function () {
            vm.processing = true;
            fileGuideService.clearSelectedNodes();
            gridDataService.genericDataService = searchService;
            appendSearchService.searchCriteria = dataCardService.searchCriteria;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "appendSearchService";
            ////reset, since it's a new search
            gridDataService.totalRecords = 0;

            //go to the grid
            $state.go('layout.results.grid').then(function () {
                gridDataService.reloadGrid();
            });
        }

        vm.refineSearch = function () {
            vm.processing = true;
            fileGuideService.clearSelectedNodes();
            refineSearchService.searchCriteria = dataCardService.searchCriteria;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "refineSearchService";
            ////reset, since it's a new search
            gridDataService.totalRecords = 0;

            //go to the grid
            $state.go('layout.results.grid').then(function () {
                gridDataService.reloadGrid();
            });
        }



        //clear the criteria from the search service
        vm.clearCriteria = function () {
            vm.dataCardService.searchCriteria = [];
            vm.schemaModels = {};
            vm.schemaModelsDates = {};
            vm.restrictedText = {};
            $rootScope.$broadcast('search:clear-criteria');
        }

        vm.selectedItemChanged = function (value, id) {
            vm.schemaModels[id] = value;
            vm.searchTextChanged(id);
        }

        $scope.$watch(function () {
            return dataCardService.searchCriteria;
        }, function (value) {
            vm.searchCriteriaDisplay = "";
            searchService.getCriteriaDisplay(value).then(function (criteriaString) {
                vm.searchCriteriaDisplay = criteriaString;
            });
        });

    }
})();
